import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { coreMediaPreviewMetadataLabel } from '../../media/core-ui-media.helpers';
import { CoreUIMediaItem } from '../../media/core-ui-media.types';

@Component({
  selector: 'core-ui-media-hover-preview-panel',
  templateUrl: './media-hover-preview-panel.component.html',
  styleUrls: ['./media-hover-preview-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CoreUIMediaHoverPreviewPanelComponent {
  @Input() item: CoreUIMediaItem | null = null;
  @Input() panelId = '';

  get previewUrl(): string | null {
    if (!this.item) return null;
    return this.item.thumbnailUrl || (this.item.type === 'image' ? this.item.url : null);
  }

  get metadata(): string {
    return this.item ? coreMediaPreviewMetadataLabel(this.item) : '';
  }
}
